<template>
  <div class="html-stil">
      <div class="body-stil">

      <h1>Nätverksterminologi</h1>



<div class="rad-container">

     <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop">    </div>
     <br>Dataöverföringsprotokoll i nätverk för pålitlig kommunikation.
     Långa meddelanden delas upp i segment som är numrerade och avsändaren
     väntar på ”kvittenser” att de kommit fram. Skickar annars igen.
</div>

<br>
<br>
<br>
<div class="rad-container">

    <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    <br>Protokoll för dataöverföring i nätverk som är snabbt och enkelt men inte har någon
    kontrollmekanism för huruvida ett meddelande gått fram eller inte.
</div>

<br>
<br>


<div class="rad-container">
    <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    <br>Den biten av en digital dataström som innehåller själva meddelandet man vill skicka
    (exklusive ip-nummer och port-nummer m.m.)
</div>
<br>
<br>
<br>
<div class="rad-container">
        <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
        <br>
        Ett heltal mellan 0 och 65535 som används i UDP/TCP-protokollen utöver
        ip-adressen för att skilja olika program/processer i samma dator åt.
</div>
    <br><br><br>
<div class="rad-container">
    <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    <br>
    Textsträng som skickas till en webbserver från en klient,  innehållande ”webbadressen” till den sida man vill se.
</div>


<br>
<br><br>
<div class="rad-container">
    <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    <br>
    En server som ”översätter” en webbadress skriven med ord/bokstäver/snedstreck t.ex. <u>www.minCoolaSida.se/hem</u>
    till exempelvis 123.182.45.56

</div>
    <br>

<br>
<br>
<div class="rad-container">
    <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    <br>En kombination av ip-nummer och portnummer (kallas även socket)
</div>
    <br><br><br>

<div class="rad-container">
    <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    <br>En teknik för att koppla ihop lokala nätverk med lokala ip-adresser till internet via en router
</div>

<br><br><br>
<div class="rad-container">

    <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
    <br>Unik ”fysisk” adress inpräntad i hårdvaran på nätverkskort o.dy.
</div>
<br><br><br>
<div class="rad-container">
  <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
  <br>Ihopkopplande av ip-adresser med mac-adresser
</div>

<br><br><br>
<div class="rad-container">
  <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
  <br>104.248.168.114
</div>

<br><br><br>
<div class="rad-container">
  <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
  <br>2001:0db8:0000:0000:0000:0000:1428:07ab/64
</div>

<br><br><br>
<div class="rad-container">
  <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
  <br>55-3A-B2-64-FD-42
</div>

<br><br><br>
<div class="rad-container">
  <div class="droptarget-i-text border" v-on:drop="drop" v-on:dragover="allowDrop"></div>
  <br>Reserverad ip-adress för ”local host”. Ett meddelande skickat med denna adress
  lämnar aldrig värddatorns nätverkskort utan skickas tillbaka till sig själv.
</div>




<div class="titellada">


<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y2">UDP - User Datagram Protocol</div>
    </div>
    </div>
<br>

<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y3">Payload</div>
    </div>
    </div>
<br>

<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y5">URL</div>
    </div>
    </div>
<br>



<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y4">portnummer</div>
    </div>
    </div>
<br>


<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y6">DNS - Domain Name Server</div>
    </div>
    </div>
<br>

    <div class="startplats">
        <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">
            <div class="y" v-on:dragstart="dragStart"   draggable="true" id="y1">TCP - Transmission Control Protocol</div>
        </div>
    </div>
    <br>


<div class="startplats">

<div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

    <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y12">IPv6 (exempel)</div>
</div>
</div>
<br>

<div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y8">NAT - Network Address Translation</div>
    </div>
    </div>

<br><div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y9">MAC-adress - Media Access Control</div>
    </div>
    </div>



  <br><div class="startplats">
      <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

          <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y7">Endpoint</div>
      </div>
      </div>


<br><div class="startplats">
    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y10">ARP - Address Resolution Protocol</div>
    </div>
    </div>


    <br><div class="startplats">

        <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

            <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y13">mac-adress (exempel)</div>
        </div>
        </div>
            <br><div class="startplats">

                <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

                    <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y15">127.0.0.1</div>
                </div>
                </div>
                <br><div class="startplats">
                    <div class="droptarget" v-on:drop="drop" v-on:dragover="allowDrop">

                        <div class="y" v-on:dragstart="dragStart"  draggable="true" id="y11">IPv4 (exempel)</div>
                    </div>
                    </div>

</div>

<br><br><br><br>

<div class="kontrollknapp" v-on:click="allaRätt()">
    Fick jag alla rätt?
</div>

<br>
<div class="m" id="rätt">
<br>Grattis! Du hade alla rätt.<br>Hurra!
</div>

<div class="m" id="fel">
<br>Du fick inte rätt. Försök igen!
</div>


<br><br><br>

<div class="info">

</div>
</div>
</div>
</template>

<script>
export default {
  name: 'Natverksterminologi',
  title () {
   return `Nätverksterminologi`
 },
  props: {
    msg: String
},
data() {
    return {
        rättaSvar:
        [
        "TCP - Transmission Control Protocol",
        "UDP - User Datagram Protocol",
        "Payload",
        "portnummer",
        "URL",
        "DNS - Domain Name Server",
        "Endpoint",
        "NAT - Network Address Translation",
        "MAC-adress - Media Access Control",
        "ARP - Address Resolution Protocol",
        "IPv4 (exempel)",
        "IPv6 (exempel)",
        "mac-adress (exempel)",
        "127.0.0.1",
      ],
            title: "Nätverksterminologi"

    }
},
methods: {
    dragStart:function(event) {
        event.dataTransfer.setData("Text", event.target.id);
  },

    /*dragging: function(event) {
        console.log("nu dragging" + event);
  },*/

     allowDrop:function(event) {
      event.preventDefault();
  },

    drop:function(event) {
      event.preventDefault();
      var data = event.dataTransfer.getData("Text");

      event.target.appendChild(document.getElementById(data));
      //event.target.classList.remove("top10");
  },

    allaRätt:function() {
    var lista = document.getElementsByClassName('border');
        var lyckades = true;

        var längd = lista.length;

        for (var i=0; i<längd; i++) {
            if (lista[i].textContent != this.rättaSvar[i]) {
                lyckades = false;
                lista[i].style.borderColor = "red";
                lista[i].style.borderWidth = "2px";
            } else {
              lista[i].style.borderColor = "black";
              lista[i].style.borderWidth = "1px";
            }
        }

        this.testresultat(lyckades);
        var that = this;
        setTimeout(function() {
            that.osynliggör()
        }, 2000);
    },

    testresultat: function(meddelande) {
        if (meddelande) {
            document.getElementById('rätt').style.display="block";
        } else {
            document.getElementById('fel').style.display="block";
        }
    },

    osynliggör: function() {
    document.getElementById('fel').style.display="none";
    }



    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.html-stil {
    background-color: white;
    padding-bottom: 10px;

}
.body-stil {
  background-color: #eee;
  margin-left: 350px;
  margin-right: 100px;
  padding-left:2em;
  padding-right:2em;
  padding-top: 0.5em;
  /*border-radius: 10px;*/
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  font-family: sans-serif;
  margin-bottom: 10px;
  text-align: left;
}

h1 {
    /*background-color: #7030a0;*/
    /*background-color: darkgreen;*/
    color: black;
    font-family: sans-serif;
    padding-top:30px;
    padding-bottom:30px;
    padding-left:5px;
    text-align: center;
}





/*fixar vit bakgrundsfärg*/
.y {
    display: inline-block;
    color: white;
    width:295px;
    text-align: center;
    line-height: 2em;
    background-color: #333;
}

.startplats {
/*    height:1.6em;*/
}


.rad-container {
    display: block;
    color: black;
    font-family: sans-serif;
    /*height: 2em;*/
    height: 100%;


}


/*Lådan som orden läggs i. I texten*/
.droptarget {
    position: relative;
    display: inline-block;
    width: 295px;
    /*height: 2em;*/
    height: 2em;
    margin-bottom: -12px;

}

.droptarget-i-text {
    position: relative;
    /*display: inline-block;*/
    width: 295px;
    /*height: 2em;*/
    height: 2em;
    /*margin-bottom: -12px;*/
    /*margin-left:30%;*/
    /*margin-left: 100px;*/

}
.border {
    border: solid 1px;
}



/*
#y1 {
    background-color: #c00000;
}


#y2 {
    background-color: #cc00cc;
}

#y3 {
    background-color: #7030a0;
}

#y4 {
    background-color: #ed7d31;
}

#y5 {
    background-color: #c00000;
}


#y6 {
    background-color: #cc00cc;
}

#y7 {
    background-color: #7030a0;
}

#y8 {
    background-color: #ed7d31;
}


#y9 {
    background-color: #c00000;
}

#y10 {
    background-color: #7030a0;
}


#y11 {
    background-color: #cc00cc;
}

#y12 {
    background-color: #ed7d31;
}


#y13 {
    background-color: #7030a0;
}

#y14 {
    background-color: #ed7d31;
}*/


.info {
    font-family: serif;
    font-size: 0.8em;
}


.titellada {
    padding:0.5em;
    width: 300px;
    height: 500px;
    /*height: 100px;*/
    position: fixed;
    background-color: #eee;
    display: block;
    top: 20px;
    left: 10px;
    font-family: sans-serif;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding-bottom: 1em;
    overflow-y:auto;
}

.bildlada {
    padding:0.5em;
    width: 200px;
    /*height: 100px;*/
    position: fixed;
    background-color: lightgrey;
    display: block;
    top: 20px;
    left: 10px;
    font-family: sans-serif;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.kontrollknapp {
    background-color: darkgrey;
    border-radius: 5px;
    border-style: solid;
    border-width:thin;
    padding: 10px;
    display: inline;
    color: white;
}

.kontrollknapp:hover {
    background-color: #bbb;
}

img {

    width: 200px;
    height: auto;
}

.m {
    font-size: 2em;
}

#rätt {
    display: none;
    color: green;
}


#fel {
    display: none;
    color: red;

}
</style>
